export const assignStringValue = (value: string | undefined, defaultValue = '', combine = false): string => {
  if (combine && value) {
    return `${value}_${defaultValue}`;
  }
  if (value === undefined) {
    return defaultValue;
  }
  return value.toString();
};
